// extracted by mini-css-extract-plugin
export default {"card":"Cards_card__HDM9Z"};